import request from '../requestPB'
import { SERVER_DOMAIN, PROTO_MODULE, STOCK_SERVER_DOMAIN } from '../constant'

// 卖家查看物流 POST /sellerOrder/express
export const sellOrderLogistics = (data) => {
  return request({
    url: `${STOCK_SERVER_DOMAIN}/sellerOrder/express`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSScOrderSellerExpressRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSScOrderSellerExpressResponse',
    ERROR_ACTION: 'toast',
    httpAddress: 'stock',
    // PROTO_MODULE: PROTO_MODULE.LOTTERY,
    TOKEN_REQUIRED: true
  })
}

// 买家查看物流 POST /buyerOrder/express
export const buyOrderLogistics = (data) => {
  return request({
    url: `${STOCK_SERVER_DOMAIN}/buyerOrder/express`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSScOrderBuyerExpressRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSScOrderBuyerExpressResponse',
    ERROR_ACTION: 'toast',
    httpAddress: 'stock',
    // PROTO_MODULE: PROTO_MODULE.LOTTERY,
    TOKEN_REQUIRED: true
  })
}